export const END_POINTS = {
  REGISTER_REQUEST: "/api/v1/request",
  REQUEST_DETAILS: "/api/v1/request",
  FILTER_REQUESTS: "/api/v1/request/filter",
  UPLOAD_FILES: "/api/v1/attachment",
  FILTER_FILES: "/api/v1/attachment/filter",
  DOWNLOAD_FILE: "/api/v1/attachment/id/download",
  DOWNLOAD_ALL_FILES: "/api/v1/entity/id/attachment/download",
  USER_REQUESTS: "/api/v1/requests",
  HISTORY: "/api/v1/request/id/audit",
  ASSIGNMENT_HISTORY: "/api/v1/request-resolver/assignment/id/audit",
  UPDATE_REQUEST: "/api/v1/request",
  CREATE_CATALOGUE: "/api/v1/admin/service-catalogue",
  FETCH_ALL_CATALOGUES: "/api/v1/admin/service-catalogues",
  CATALOGUE_DETAILS: "/api/v1/admin/service-catalogue",
  FILTER_CATALOGUE: "/api/v1/admin/service-catalogue/filter",
  UPDATE_CATALOGUE: "/api/v1/admin/service-catalogue",
  FETCH_ALL_LEGAL_TEAMS: "/api/v1/admin/teams",
  TEAM_DETAILS: "/api/v1/admin/team",
  CREATE_TEAM: "/api/v1/admin/team",
  FILTER_TEAM: "/api/v1/admin/team/filter",
  UPDATE_TEAM: "/api/v1/admin/team/",
  FILTER_FORM: "/api/v1/admin/form/filter",
  CREATE_LOCATION: "/api/v1/admin/location",
  FILTER_LOCATION: "/api/v1/admin/location/filter",
  UPDATE_LOCATION: "/api/v1/admin/location/",
  CREATE_ASSIGNMENT_MATRIX: "/api/v1/admin/assignment-matrix",
  FILTER_ASSIGNMENT_MATRIX: "/api/v1/admin/assignment-matrix/filter",
  UPDATE_ASSIGNMENT_MATRIX: "/api/v1/admin/assignment-matrix",
  FILTER_GEMS_ENTITIES: "/api/v1/admin/legal-entity/filter",
  FILTER_PRACTITIONER_REQUESTS: "/api/v1/request-resolver/assignment/filter",
  FETCH_PRACTITIONER_REQUESTS: "/api/v1/request-resolver/assignment/id",
  UPDATE_PRACTITIONER_REQUESTS: "/api/v1/request-resolver/request/id",
  CREATE_COLLABORATOR: "/api/v1/request-resolver/collaborator",
  FILTER_COLLABORATOR: "/api/v1/request-resolver/collaborator/filter",
  UPDATE_COLLABORATOR: "/api/v1/request-resolver/collaborator/id",
  COLLABORATOR_AUDIT: "/api/v1/request-resolver/collaborator/request/id/audit",
  REQUEST_ASSIGNMENT: "/api/v1/request-resolver/assignment/id",
  FILTER_REQUEST_NOTES: "/api/v1/request-resolver/notes/filter",
  FETCH_REQUEST_NOTES: "/api/v1/request-resolver/notes/id",
  CREATE_REQUEST_NOTES: "/api/v1/request-resolver/request/notes",
  FETCH_REQUEST_FORM_SCHEMA: "/api/v1/admin/form/id",
  FETCH_USER: "/api/v1/user/id",
  CREATE_USER: "/api/v1/user",
  UPDATE_USER: "/api/v1/user/id",
  FILTER_USERS: "/api/v1/user/filter",
  GRAPH_ME: "https://graph.microsoft.com/v1.0/me",
  GRAPH_USERS: "https://graph.microsoft.com/v1.0/users",
  GRAPH_GROUPS: "https://graph.microsoft.com/v1.0/groups",
  GRAPH_MEMBERSHIPS: "https://graph.microsoft.com/v1.0/users/id/checkMemberGroups",
  AZURE_GROUPS_URL:
    "https://portal.azure.com/#view/Microsoft_AAD_IAM/GroupDetailsMenuBlade/~/Overview/groupId/GROUP_ID/menuId/",
  GRAPH_EMAIL_DRAFT: "https://graph.microsoft.com/v1.0/me/messages",
  GRAPH_EMAIL_ATTACHMENT: "https://graph.microsoft.com/v1.0/me/messages/messageId/attachments",
  GRAPH_OPEN_WEB_OUTLOOK: "https://graph.microsoft.com/v1.0/me/messages/messageId?$select=webLink",
  GRAPH_CHAT: "https://graph.microsoft.com/v1.0/chats",
  GRAPH_CHAT_MESSAGE: "https://graph.microsoft.com/v1.0/chats/chatId/messages",
  /** Substitute `{siteId}` and `{listId}` literally (SharePoint site ids often contain commas — do not encode). */
  GRAPH_SHAREPOINT_LIST_ITEMS: "https://graph.microsoft.com/v1.0/sites/{siteId}/lists/{listId}/items",
  GRAPH_SHAREPOINT_LIST_ITEM_DRIVE_ITEM:
    "https://graph.microsoft.com/v1.0/sites/{siteId}/lists/{listId}/items/{itemId}/driveItem",
  GRAPH_DRIVE_ITEM_CONTENT: "https://graph.microsoft.com/v1.0/drives/{driveId}/items/{itemId}/content",
  GRAPH_DRIVE_ITEM_PREVIEW: "https://graph.microsoft.com/v1.0/drives/{driveId}/items/{itemId}/preview"
};
